var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWheel = function SvgWheel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 271,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-140.958 0-256 115.049-256 256 0 140.961 115.049 256 256 256 140.96 0 256-115.049 256-256 0-140.958-115.049-256-256-256zm0 61c97.323 0 178.219 71.668 192.692 165h-52.019c-32.982 0-64.318-13.235-85.973-36.311-29.6-31.546-79.797-31.556-109.4-.001-21.655 23.077-52.991 36.312-85.974 36.312h-52.018c14.473-93.332 95.369-165 192.692-165zm0 255c-24.812 0-45-20.186-45-45s20.188-45 45-45c24.814 0 45 20.186 45 45s-20.186 45-45 45zm-181.58 11.097c17.17-6.736 29.568-11.097 46.58-11.097 54.688 0 97.219 48.734 88.981 103.49h-.035c-1.224 8.381-3.632 16.502-7.105 24.145-58.759-16.67-106.31-60.262-128.421-116.538zm234.751 116.534c-3.568-7.845-5.924-15.965-7.117-24.141h-.035c-9.599-63.805 49.301-116.452 110.354-100.936 6.436 1.636 14.49 4.34 25.206 8.544-22.109 56.271-69.655 99.861-128.408 116.533z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wheel.c2ad472d.svg";
export { ForwardRef as ReactComponent };